export default {
  // 首页
  home: {
    ProductServices: '产品服务',
    StoreOverview: '门店概览',
    StoreDistribution: '门店分布',
    StoreCountRanking: '门店数排行',
  },
};
